import { Component, Input } from "@angular/core";
import { UntypedFormGroup } from "@angular/forms";

@Component({
    selector: "send-mail-til-forbruger",
    templateUrl: "./send-mail-til-forbruger.component.html"
})
export class SendMailTilForbrugerComponent {
    @Input() public formGroup: UntypedFormGroup;
}
